export const COMPETITION_ENTITY = 'competition';
export const BETTING_M_VALUE_ENTITY = 'betting_m_value';
export const BETTING_LOGO_ENTITY = 'betting_logo';
export const TEAM_ENTITY = 'team';
export const PLAYER_ENTITY = 'player';
export const EVENT_ENTITY = 'event';
export const IMAGE_ENTITY = 'image';
export const COACH_ENTITY = 'coach';
export const USER_INTERACTION = 'user_interaction';
export const STANDINGS_ENTITY = 'standings';
